import React from 'react'
import { Card } from 'react-bootstrap'
import { CARD_HEADER_BG } from '../../../utils/styleAliases'

import TableData from '../../layout/cards-containers/TableData'

import {
  calculateHandlebarReach,
  calculateHandlebarStack
} from '../../../lib/tools-js-functions'

import { handlebarReachAndStackForm as dataForm } from '../../forms/form-objects/toolsFormObjects'

const BarToFrameOutputs = ({ inputs, user }) => {
  return (
    <Card>
      <Card.Header className={CARD_HEADER_BG}>
        <Card.Title>Frame Reach and Stack</Card.Title>
      </Card.Header>
      <Card.Body>
        <TableData
          dataForm={dataForm}
          dataObject={{
            handlebarReachHX: calculateHandlebarReach(inputs),
            handlebarStackHY: calculateHandlebarStack(inputs)
          }}
          user={user}
        />
      </Card.Body>
    </Card>
  )
}

export default BarToFrameOutputs
